// extracted by mini-css-extract-plugin
export default {"eventContainer":"Proposal_eventContainer__R78KH","housingCommitteeContainer":"Proposal_housingCommitteeContainer__63bAK"};